import React, { Component } from 'react'

export default (props) => {
    return (
        <div className="qInputTextContainer">
            <input
                type="text"
                {...props}
                placeholder="Sök"
                className="qInputText"
            />
        </div>
    )
}